import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";





import { PrimaryLog } from "../../../../timber/types/models/Log";

import LogFormSelect from "../../../../timber/components/log/LogForm/LogFormSelect";

import { useGetLogQuery } from "../../../../timber/apis/Log.api";



































































import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";











export const initialFormStateFn = () => { return {
    
        
        logId: null,
        
    
        
        action: "",
        
    
        
        contextHistory: "",
        
    
        
        state: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.logId = PrimaryLog.fromQuery(location.state?.logId) || null;
    

    const { data: logIdData } = useGetLogQuery(PrimaryLog.fromId(initialFormState.logId), { skip: !initialFormState.logId })
    

    return React.useMemo(() => initialFormState, [
        location.state,
        logIdData,
        
        
    ])
}

export const formObject = {
    
    
        logId:
        string()
                .nanoid(msg`Log is required`)
                .min(1, msg`Log is required`),
    
    
        action:
        string()
        .trim()
        .min(1, msg`Action is required`),
    
    
        contextHistory:
        string()
        .trim()
        .nullish(),
    
    
        state:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);

const LogHistoryAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <LogFormSelect
        type="none"
        name="logId"
        label={t`Log`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'action' }
       aria-label="action"
       data-testid="action"
       label={t`Action`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'contextHistory' }
       aria-label="contextHistory"
       data-testid="contextHistory"
       label={t`Context History`}
       
       type='text'
       
   />
   
   
           
           
   
    <crudgen.FormSelect
        
        name={ prefix + 'state' }
        aria-label="state"
        label={t`State`}
        options={ ShipmentStatePairs }
        optionLabelMap={ toStringShipmentState }
    />
   
   
           
        </Container>
    )
}

export default LogHistoryAddForm;
